import { getInitialState, getPath } from "../../utils";
import ActionTypes from "../actions/ActionTypes";

const initialState = {
  activeFilters: {},
  capacityChangeRequests: [],
  userAttributes: [],
  carrierList: [],
  entityList: [],
  nextPage: -1,
  prevPage: -1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_CAPACITY_CHANGE_ATTRIBUTES: {
      return setUserAttributes(state, action);
    }
    case ActionTypes.SET_CAPACITY_CHANGE_REQUESTS: {
      return setCapacityChangeRequestData(state, action);
    }
    case ActionTypes.RESET_CAPACITY_CHANGE_STORE: {
      return resetState(state, action);
    }
    case ActionTypes.SET_ENTITY_LIST_CAPACITY_CHANGE: {
      return setEntityList(state, action);
    }
    case ActionTypes.SET_ACTIVE_FILTERS_CAPACITY_CHANGE: {
      return setActiveFilters(state, action);
    }
    default: {
      return state;
    }
  }
}

const setUserAttributes = (state, action) => {
  return {
    ...state,
    userAttributes: getPath(action.payload, "city_zones", []),
    carrierList: getPath(action.payload, "carrier_types", []),
  };
};

const setCapacityChangeRequestData = (state, action) => {
  return {
    ...state,
    capacityChangeRequests: getPath(action.payload, "list", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};

const setEntityList = (state, action) => {
  return {
    ...state,
    entityList: action.payload || [],
  };
};

const setActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
